import {useEffect} from 'react';

import {useParams} from 'react-router-dom';

import {Grid} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
    TabbedComponent,
    TabComponentTab,
} from '@flexinet/ui-components';
import {Profile} from '../components/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useSubscription} from '../hooks/useSubscription.ts';

import {useEditPageTools} from '../hooks/useEditPageTools';

import {useSubscriptions} from "../hooks/useSubscriptions.ts";
import {IndexPage as SubscriptionItemsPage} from "../../subscription-items/pages/IndexPage.tsx";


export const EditPage = () => {

    const {subscriptionId} = useParams();

    if (typeof subscriptionId === 'undefined') {
        throw new Error('subscriptionId is required parameter');
    }

    const {fetchRecords} = useSubscriptions();

    const {
        record: subscription,
        fetchRecord,
        updateRecord,
    } = useSubscription(subscriptionId);

    const {
        mode,
        tools,
    } = useEditPageTools();

    useEffect(() => {
        fetchRecords();
    }, []);

    useEffect(() => {
        fetchRecord();
    }, [subscriptionId]);

    if (!subscription) {
        return <PlatformLoader message='Loading subscription...Please wait'/>;
    }

    const tabs = [
        {
            title: 'Line Items',
            component: <SubscriptionItemsPage subscriptionId={subscriptionId}/>
        },
    ] as TabComponentTab[];


    return (
        <FormPageLayout
            title={subscription.id}
            pageNavigation={<EditPageNavigation component={subscription}/>}
            tools={tools}
        >


            {mode === 'view' ?

                <Grid>
                    <Grid.Col span={{
                        base: 12,
                        lg: 3
                    }}>
                        <Profile record={subscription}/>

                    </Grid.Col>
                    <Grid.Col span={{
                        base: 12,
                        lg: 9
                    }}>
                        <TabbedComponent tabs={tabs}/>
                    </Grid.Col>
                </Grid>


                :
                <RecordForm
                    record={subscription}
                    handleSubmit={updateRecord}
                />}


        </FormPageLayout>
    );
};
